import * as React from 'react';
import { browserHistory } from 'react-router';
import './Tags.scss';

type IProps = {
	tags: string;
	onClick: boolean;
	displayNumber?: number;
};

export const Tags = (props: IProps) => {
	const { tags, displayNumber, onClick } = props;
	const tagsArray = tags && tags.split(' ');
	const [expanded, setExpanded] = React.useState(false);

	const expandTags = () => {
		setExpanded(!expanded);
	};

	const handleOnTagClick = (tag: string) => {
		browserHistory.push('/magazine/search/tag/' + encodeURIComponent(tag));
	};

	return (
		<div className="tagsContainer">
			{tagsArray &&
				tagsArray.map((tag, i) => {
					if (!expanded && displayNumber && i >= displayNumber) {
						if (i === displayNumber) {
							return (
								<div className="tagArticle onClick" onClick={() => expandTags()} key={i}>
									...
								</div>
							);
						}
					} else {
						return (
							<div
								className={onClick ? 'tagArticle onClick' : 'tagArticle'}
								onClick={onClick ? () => handleOnTagClick(tag) : null}
								key={i}
							>
								{tag}
							</div>
						);
					}
				})}
			{expanded && (
				<div className="tagArticle onClick" onClick={() => expandTags()} key={tagsArray.length + 1}>
					...
				</div>
			)}
		</div>
	);
};
